import { UncastedOrder } from '@goldwasserexchange/oblis-frontend-utils';

export const hasPrevious = (order: unknown): order is {
  previous: UncastedOrder['previous'],
} => {
  if (order == null) {
    return false;
  }
  if (typeof order !== 'object') {
    return false;
  }
  if (!('previous' in order)) {
    return false;
  }
  if (typeof order.previous !== 'string') {
    return false;
  }
  return true;
};

export const getProductId = (order: unknown) => {
  if (order == null) {
    return '';
  }
  if (typeof order !== 'object') {
    return '';
  }
  if (!('productId' in order)) {
    return '';
  }
  if (typeof order.productId !== 'string') {
    return '';
  }
  return order.productId;
};

export const isOrder = (order: unknown): order is UncastedOrder => {
  if (typeof order !== 'object' || order === null) {
    return false;
  }
  const {
    direction,
    productId,
    accountId,
    orderType,
    validity,
    price,
    currency,
  } = order as Record<string, unknown>;
  return typeof direction === 'string' && (direction === 'BUY' || direction === 'SELL')
  && typeof productId === 'string'
  && typeof accountId === 'string'
  && typeof orderType === 'string' && (orderType === 'MARKET' || orderType === 'LIMIT')
  && typeof validity === 'string' && (validity === 'DAY' || validity === 'WEEK' || validity === 'MONTH')
  && typeof price === 'string'
  && typeof currency === 'string';
};
